var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.$style.container }, [
        _c("div", {
          attrs: {
            "data-pp-message": "",
            "data-pp-buyerCountry": _vm.runConfig.country,
            "data-pp-amount": _vm.amount,
            "data-pp-placement": _vm.placement,
            "data-pp-style-text-size": _vm.textSize,
            "data-testid": "paypal-paylater"
          }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }